<mapfre-loading *ngIf="loading"></mapfre-loading>
<mapfre-alert *ngIf="showAlert" [closeButton] = "true" [notTop]="false"></mapfre-alert>
<mapfre-alert [notTop]="false" [closeButton] = "true" *ngIf="!showAlert"></mapfre-alert>
<ng-container *ngFor="let policy of policyDetails">
  <ng-container *ngIf="policy.policynumber.policyNumber === policyId && !loading">

    <ng-container *ngIf="policy?.policyType.toUpperCase().includes('AUTO')">
      <mapfre-card 
        [singleCard]="false"
        [additionalClasses]="'policy-details details car-class '  + policy?.policyType">
        <div class="bn-details-header-wrap" *ngIf="!isAcmic">
          <div class="row" [ngClass]="{'no-margin-horizontal': !isAcmic}">
            <div class="col no-padding-right no-padding-top" [ngClass]="{'no-padding-left': !isAcmic}">
              <ng-container>
                  <mapfre-button
                      additionalClasses="link-button red-link top-information no-padding font-weight-normal details-back-text details-back-text-auto "
                    [backIcon]="'assets/img/icons/back-arrow-red.png'" [iconClasses]="'align-middle pr-2'"
                      [showIconsCustom]="true" routerLink="/my-insurance"> {{ 'Back' | translate }}
                  </mapfre-button>
              </ng-container>
            </div>
          </div>
          <div class="bn-dtails-header-title">
            Policy details
          </div>
        </div>
        <app-car-header     [policy]="policy" *ngIf="isAcmic"></app-car-header>
        <app-dashboard-nav class="details-nav-gap" [policyId]="policyId" [policyType] = "policy?.policyType"></app-dashboard-nav>
        <app-details-car    [policy]="policy" [policyIdInput]="policyId" (showToast)="showToastMessage($event)" (showMileageToast)="showMileageToastMessage($event)"></app-details-car>
      </mapfre-card>
    </ng-container>
  
    <ng-container *ngIf="policy?.policyType.toUpperCase().includes('HOME')">
      <mapfre-card 
        [singleCard]="false"
        [additionalClasses]="'policy-details details property ' + policy?.policyType">
         <div class="bn-details-header-wrap" *ngIf="!isAcmic">
          <div class="row">
            <div class="col no-padding-right no-padding-top">
              <ng-container>
                  <mapfre-button
                      additionalClasses="link-button red-link top-information no-padding font-weight-normal details-back-text"
                    [backIcon]="'assets/img/images/arrow-left.svg'" [iconClasses]="'align-middle pr-2 details-arrow-left'"
                      [showIconsCustom]="true" routerLink="/my-insurance"> {{ 'Back' | translate }}
                  </mapfre-button>
              </ng-container>
            </div>
          </div>
          <div class="bn-dtails-header-title">
            Policy details
          </div>
        </div>
        <app-home-header    [policy]="policy" *ngIf="isAcmic"></app-home-header>
        <app-dashboard-nav class="details-nav-gap" [policyId]="policyId" [policyType] = "policy?.policyType"></app-dashboard-nav>
        <app-details-home   [policy]="policy" (showToast)="showToastMessage($event)"></app-details-home>
      </mapfre-card>
    </ng-container>

    <ng-container *ngIf="!policy?.policyType.toUpperCase().includes('AUTO') && !policy?.policyType.toUpperCase().includes('HOME') ">
      <mapfre-card 
        [singleCard]="false"
        [additionalClasses]="'policy-details details property ' + policy?.policyType ">
        <div class="bn-details-header-wrap" *ngIf="!isAcmic">
          <div class="row">
            <div class="col no-padding-right no-padding-top">
              <ng-container>
                  <mapfre-button
                      additionalClasses="link-button red-link top-information no-padding font-weight-normal details-back-text"
                    [backIcon]="'assets/img/images/arrow-left.svg'" [iconClasses]="'align-middle pr-2 details-arrow-left'"
                      [showIconsCustom]="true" routerLink="/my-insurance"> {{ 'Back' | translate }}
                  </mapfre-button>
              </ng-container>
            </div>
          </div>
          <div class="bn-dtails-header-title">
            Policy details
          </div>
        </div>
        <app-all-header    [policy]="policy" *ngIf="isAcmic" ></app-all-header>
        <app-dashboard-nav class="details-nav-gap" [policyId]="policyId" [policyType] = "policy?.policyType"></app-dashboard-nav>
        <app-details-all   [policy]="policy" (showToast)="showToastMessage($event)"></app-details-all>
      </mapfre-card>
    </ng-container>

  </ng-container>
</ng-container>
